import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Events Calendar', path: '/events' },
    { name: 'Journey So Far', path: '/journey' },
    { name: 'Get In Touch', path: '/contact' }
  ];

  return (
    <nav className="dark-header">
      <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap">
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`nav-button ${
              location.pathname === link.path ? 'nav-button-active' : ''
            } ${link.name === 'Get In Touch' ? 'nav-button-highlight' : ''}`}
          >
            {link.name}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
